import React, { useEffect, useMemo, useState } from "react";
import StatsCard from "../UI/staticsCard";
import DataTable from "../UI/table/DataTable";
import FilterBar from "../UI/filterbar";
import { useQuery } from "react-query";
import { getDelivery, getDeliveryStatics } from "../../MyApi/delivery";
import {
  shippinColumns,
  shippingStatsConfig,
} from "../../pages/shipping/shippingdata";

const ShippingsTab = ({ onAddClick }) => {
  useEffect(() => {
    console.log("shippingTabMount");
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    is_active: "",
  });

  const {
    data: deliveryData,
    isLoading: isDeliveryLoading,
    error,
  } = useQuery(["getdeliveryData", currentPage, filters], () =>
    getDelivery(currentPage, filters),
  );
  const { data: deliveryStaticsData, isLoading: isLoadingStats } = useQuery(
    "getDeliveryStatics",
    getDeliveryStatics,
  );

  const deliveryCompaines = deliveryData?.data?.delivery_company || [];
  const deliveyStatics = deliveryStaticsData?.data || {};
  const totalItems = deliveryData?.data?.pagination?.total || 0;
  const lastPage = deliveryData?.data?.pagination?.last_page || 0;

  const shippingStats = useMemo(() => {
    return shippingStatsConfig(deliveyStatics);
  }, [deliveyStatics]);

  const handleResetFilters = () => {
    setFilters({
      search: "",
      is_active: "",
    });
    setCurrentPage(1);
  };

  return (
    <>
      <div className="row g-3 mt-3">
        {shippingStats?.map((stat, index) => (
          <div className="col-md" key={index}>
            <StatsCard {...stat} isLoading={isLoadingStats} />
          </div>
        ))}
      </div>

      <FilterBar
        filters={filters}
        setFilters={setFilters}
        filtersConfig={{
          search: "search",
          is_active: "is_active",
        }}
        placeholder="ابحث باسم الشركة أو البريد الإلكتروني أو رقم الهاتف..."
        onResetFilters={handleResetFilters}
      />

      <div className="mt-4">
        <DataTable
          columns={shippinColumns}
          data={deliveryCompaines}
          title={"شركات الشحن"}
          onAddClick={onAddClick}
          actionLabel={"إضافة شركات شحن"}
          emptyMessage="لا توجد بيانات لشركات الشحن"
          itemsPerPage={lastPage}
          totalItems={totalItems}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={isDeliveryLoading}
          createPermission={"create_delivery_company"}
          error={error}
        />
      </div>
    </>
  );
};

export default ShippingsTab;
